export const ContactActionType = {
  SEND_API: 'CONTACT.SEND_API',
  SEND_API_SUCCESS: 'CONTACT.SEND_API_SUCCESS',
  SEND_API_FAILURE: 'CONTACT.SEND_API_FAILURE'
}